import script from "./TheOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./TheOverlay.vue?vue&type=style&index=0&id=3169a4ea&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3169a4ea"]])

export default __exports__